import React from "react";

import { component_tool } from '@/tool';
const { WizModal, WizButton } = component_tool;
import moment from "moment";
import LlmSetting from "../llmSetting";
//配置项
let componentName = 'ReviewTask'


const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "任务名称",
      name: "title",
      dataIndex: "title",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "任务开始时间",
      name: "startDate",
      dataIndex: "startDate",
      tableItem: {},
    },
    {
      title: "任务结束时间",
      name: "endDate",
      dataIndex: "endDate",
      tableItem: {},
    },
    {
      title: "任务状态",
      name: "state",
      dataIndex: "state",
      dict: [
        { code: 0, codeName: "草稿" },
        { code: 1, codeName: "已发布" },
        { code: 2, codeName: "已关闭" },
      ],
      searchItem: {
        type: "select"
      },
      tableItem: {},
    },
  ]
}

const templateConfig = () => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(),
        searchBarProps: {
          buttonSort: ['add', 'delete', 'export'],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { children: "新增", icon: "plus", type: "primary" },
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: '/online/reviewTask/add',
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: {
                icon: "export", children: "导出", type: "export"
              },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },

        rowOperateSort: ['look', 'update', 'releaseOrClose', 'llmSetting'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: { children: "查看" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/online/reviewTask/look",
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/online/reviewTask/upd",
              }
            }
          },
          {
            key: "releaseOrClose",
            custom: true,
            params: { children: "发布"},
            textFormat: {
              recordKey: 'state',
              dirt: { 0: '发布', 1: '关闭', 2: "发布"}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateState",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 1 ? "关闭" : "发布"
                }该任务吗？`;
                WizModal.confirm({
                  title: '注意',
                  content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 1 ? 2 : 1,
                      id: record['id'],
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "llmSetting",
            custom: true,
            params: { children: "模型参数" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "模型参数",
                  diy: (e) => {
                    const {changeModal, record} = e || {}
                    const {id} = record || {}
                    return <LlmSetting changeModal={changeModal} bizId={id}/>
                  },
                  width: 700,
                  footer: false,
                  destroyOnClose: true,
                }
              }
            }
          },
        ]
      }
    }
  }
};

const apis = () => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: { }
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { }
      }
    },
    updateState: {
      path: `${componentName}/updateState`,
      payload: {
        key: `${componentName}@updateState`,
        apiParams: { }
      }
    },
  }
}


const reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
